<template>
  <div class="user-page full-height">
    <tableCon>
      <div slot="breadcrumb">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/container' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>FBA装箱单管理</el-breadcrumb-item>
          <el-breadcrumb-item>FBA装箱单列表</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div slot="search">
        <el-collapse v-show="isActive">
          <el-row class="search-row">
            <el-col :span="6" class="display-row">
              <div class="query-title">装箱批次号:</div>
              <div class="flex1">
                <el-input placeholder="请输入内容" clearable v-model="queryInfo.containerBatchNo" size="small" @keyup.enter.native="searchList">
                </el-input>
              </div>
            </el-col>
            <el-col :span="6" class="display-row">
              <div class="query-title">客户ID:</div>
              <div class="flex1">
                <el-input placeholder="请输入内容" clearable v-model="queryInfo.userName" size="small" @keyup.enter.native="searchList">
                </el-input>
              </div>
            </el-col>
            <el-col :span="6" class="display-row">
              <div class="query-title">客户姓名:</div>
              <div class="flex1">
                <el-input placeholder="请输入内容" clearable v-model="queryInfo.realName" size="small" @keyup.enter.native="searchList">
                </el-input>
              </div>
            </el-col>
            <!-- <el-col :span="6" class="display-row">
              <div class="query-title">状态:</div>
              <div class="flex1">

                <el-select v-model="queryInfo.containerState"
                           placeholder="请选择"
                           size="small" clearable>
                  <el-option
                      v-for="item in containerStateList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                  </el-option>
                </el-select>
              </div>
            </el-col> -->
            <el-col :span="6" class="display-row">
              <div class="query-title">发送地区:</div>
              <div class="flex1">
                <el-input placeholder="请输入内容" clearable v-model="queryInfo.sendArea" size="small" @keyup.enter.native="searchList">
                </el-input>
              </div>
            </el-col>
          </el-row>
          <el-row class="search-row">
            <el-col :span="6" class="display-row">
              <div class="query-title">物流公司:</div>
              <div class="flex1">

                <el-select v-model="queryInfo.logisticsCompanyId" placeholder="请选择" size="small" clearable>
                  <el-option v-for="item in dropDownList" :key="item.id" :label="item.companyName" :value="item.id">
                  </el-option>

                </el-select>
              </div>
            </el-col>
            <el-col :span="6" class="display-row">
              <div class="query-title">国际运单号:</div>
              <div class="flex1">
                <el-input placeholder="请输入内容" clearable v-model="queryInfo.waybillNumber" size="small" @keyup.enter.native="searchList">
                </el-input>
              </div>
            </el-col>
            <el-col :span="6" class="display-row">
              <div class="query-title">线路:</div>
              <div class="flex1">
                <el-select v-model="queryInfo.route" placeholder="请选择" size="small" clearable>
                  <el-option v-for="item in routeList" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </div>
            </el-col>
            <el-col :span="6" class="display-row">
              <div class="query-title">创建开始日:</div>
              <div class="flex1">
                <el-date-picker clearable v-model="queryInfo.createTimeStart" type="date" size="small" format="yyyy-MM-dd" value-format="yyyy-MM-dd"
                  placeholder="选择日期">
                </el-date-picker>
              </div>
            </el-col>
          </el-row>
          <el-row class="search-row">
            <el-col :span="6" class="display-row">
              <div class="query-title">创建结束日:</div>
              <div class="flex1">
                <el-date-picker clearable v-model="queryInfo.createTimeEnd" type="date" size="small" format="yyyy-MM-dd" value-format="yyyy-MM-dd"
                  placeholder="选择日期">
                </el-date-picker>
              </div>
            </el-col>
            <el-col :span="6" class="display-row">
              <div class="query-title">发送开始日:</div>
              <div class="flex1">
                <el-date-picker clearable v-model="queryInfo.sendTimeStart" type="date" size="small" format="yyyy-MM-dd" value-format="yyyy-MM-dd"
                  placeholder="选择日期">
                </el-date-picker>
              </div>
            </el-col>
            <el-col :span="6" class="display-row">
              <div class="query-title">发送结束日:</div>
              <div class="flex1">
                <el-date-picker clearable v-model="queryInfo.sendTimeEnd" type="date" size="small" format="yyyy-MM-dd" value-format="yyyy-MM-dd"
                  placeholder="选择日期">
                </el-date-picker>
              </div>
            </el-col>
          </el-row>
        </el-collapse>
        <el-row class="search-row">
          <el-col :span="24" class="display-row">
            <div class="search-btn-container search-btn-container-status">
              <el-button class="search-btn btn-white" :class="{lxBtnGreenDeep: curIndex === ''}" @click="changeTab('')">全部
              </el-button>
              <!-- <el-button class="search-btn btn-white" :class="{lxBtnGreenDeep: curIndex === 6}" @click="changeTab(6)">待装箱<span
                  class="lx-red">({{containerCount.waitBoxCount}})</span></el-button> -->
              <el-button class="search-btn btn-white" :class="{lxBtnGreenDeep: curIndex === 10}" @click="changeTab(10)">可装箱<span
                  class="lx-red">({{containerCount.canBoxCount}})</span></el-button>
              <el-button class="search-btn btn-white" :class="{lxBtnGreenDeep: curIndex === 0}" @click="changeTab(0)">装箱中<span
                  class="lx-red">({{containerCount.boxCount}})</span></el-button>
              <el-button class="search-btn btn-white" :class="{lxBtnGreenDeep: curIndex === 7}" @click="changeTab(7)">装箱完<span
                  class="lx-red">({{containerCount.finishBoxNum}})</span></el-button>

              <el-button class="search-btn btn-white" :class="{lxBtnGreenDeep: curIndex === 8}" @click="changeTab(8)">盘点完<span
                  class="lx-red">({{containerCount.inventoryCount}})</span></el-button>
              <el-button class="search-btn btn-white" :class="{lxBtnGreenDeep: curIndex === 9}" @click="changeTab(9)">待发账单<span
                  class="lx-red">({{containerCount.billCount}})</span></el-button>

              <el-button class="search-btn btn-white" :class="{lxBtnGreenDeep: curIndex === 1}" @click="changeTab(1)">待支付<span
                  class="lx-red">({{containerCount.waitPayCount}})</span></el-button>
              <el-button class="search-btn btn-white" :class="{lxBtnGreenDeep: curIndex === 11}" @click="changeTab(11)">待确认(国际运费)<span
                  class="lx-red">({{containerCount.confirmCount}})</span></el-button>
              <el-button class="search-btn btn-white" :class="{lxBtnGreenDeep: curIndex === 2}" @click="changeTab(2)">待传发票<span
                  class="lx-red">({{containerCount.invoicePendingCount}})</span></el-button>
              <el-button class="search-btn btn-white" :class="{lxBtnGreenDeep: curIndex === 3}" @click="changeTab(3)">待发送<span
                  class="lx-red">({{containerCount.waitSendCount}})</span></el-button>
              <el-button class="search-btn btn-white" :class="{lxBtnGreenDeep: curIndex === 4}" @click="changeTab(4)">已发送<span
                  class="lx-red"></span></el-button>
              <el-button class="search-btn btn-white" :class="{lxBtnGreenDeep: curIndex === 5}" @click="changeTab(5)">已取消<span
                  class="lx-red"></span></el-button>
            </div>
          </el-col>
        </el-row>
        <el-row class="search-row">
          <el-col :span="24" class="display-row">
            <div class="search-btn-container" style="text-align:right">
              <el-button class="search-btn btn-gray" @click="queryInfoClear">重置</el-button>
              <el-button class="search-btn btn-blue" @click="searchList()">搜索</el-button>
              <el-button class="search-btn btn-blue" @click="toSort">排序</el-button>
              <el-button class="search-btn btn-blue" @click="toExport" v-if="curIndex == 4">导出</el-button>
              <el-button class="search-btn btn-blue" v-if="!isActive" type="primary" icon="el-icon-arrow-down" alt=""
                         @click="isActive = !isActive">展开</el-button>
              <el-button class="search-btn btn-green" v-if="isActive" icon="el-icon-arrow-up" alt="" @click="isActive = !isActive">收起</el-button>
            </div>
          </el-col>
        </el-row>
      </div>
      <!-- 内容 -->
      <div slot="table" class="full-height display-col">
        <el-table ref="multipleTable" :data="containerList" :header-cell-style="tableStyle.headerStyle" :cell-style="tableStyle.cellStyle" v-loading="isLoading" border stripe
          style="width: 100%" height="550">
          <el-table-column type="index" align="center" label="序号" width="40"></el-table-column>
          <el-table-column :show-overflow-tooltip="item.key === 'comments'" v-for="(item, index) in asyncColumns" :key="index" align="center" :label="item.name"
            :prop="item.key" :width="item.width?item.width:'auto'" :min-width="item.minWidth?item.minWidth:'auto'">
            <template v-slot="scope">
              <!-- 订单操作 -->
              <div v-if="item.key === 'handle'" style="display: inline-block" class="btn-row">

                <el-button class="list-btn-four btn-blue" @click="remind(scope.row)">
                  提醒
                </el-button>
                <div v-has="{role:['edit','admin']}">
<!--                  scope.row.containerState==9 ||
                  scope.row.containerState==1 ||
                  scope.row.containerState==2 ||
                  scope.row.containerState==3 ||-->
<!--                  <el-button
                    class="list-btn-four btn-blue"
                    v-if="
                    scope.row.containerState==8 ||
                    scope.row.containerState==4 ||
                    scope.row.containerState==5 ||
                    scope.row.containerState==9 ||
                    scope.row.containerState==1 ||
                    scope.row.containerState==2
                  "
                    @click="upDataStatus(scope.row)"
                  >
                    修改状态
                  </el-button>-->
                </div>
                <el-button class="list-btn-four btn-blue" v-if="scope.row.realWeight != null && scope.row.containerState!=5" @click="toContainerDetail(scope.row)">
                  装箱详情
                </el-button>
                <el-button class="list-btn-four btn-deepblue" v-if="scope.row.containerState!=5" @click="ModifyContainer(scope.row)">编辑
                </el-button>
                <el-button class="list-btn-four btn-red" v-if="scope.row.containerState ==8 || scope.row.containerState ==9 "
                  @click="addSendBill(scope.row)">发送账单
                </el-button>
                <el-button class="list-btn-four btn-blue"
                  v-if="
                  scope.row.containerState !=0 &&
                  scope.row.containerState !=5 &&
                  scope.row.containerState !=6 &&
                  scope.row.containerState !=7 &&
                  scope.row.containerState !=9 &&
                  scope.row.containerState != 10"
                  @click="addBill(scope.row)">
                  账单
                </el-button>
                <el-button class="list-btn-four  btn-red" v-if="scope.row.containerState ==9" @click="cannelBill(scope.row)">取消
                </el-button>
                <el-button class="list-btn-four  btn-deepblue"
                  @click="ContainerOrderList(scope.row.containerBatchNo, scope.row.customerId, scope.row.id, scope.row.containerState)">
                  装箱单
                </el-button>
                <!-- <el-button class="list-btn-four  btn-deepblue" v-if="scope.row.boxUrl"
                           @click="downBoxUrl(scope.row.boxUrl)">
                  装箱单明细下载
                </el-button> -->

                <el-button class="list-btn-four btn-green" v-if="scope.row.containerState == 6" @click="canBoxStatus(scope.row)">可装箱</el-button>

                <el-button class="list-btn-four  btn-deepblue" v-if="scope.row.containerState ==1 || scope.row.containerState ==2 || scope.row.containerState ==3 || scope.row.containerState ==11" @click="invoiceExport(scope.row)">
                  {{getGenerateInvoiceDataStatusStr(scope.row.generateInvoiceData)}}
                </el-button>

                <el-button class="list-btn-four  btn-green" v-if="(scope.row.containerState ==1 || scope.row.containerState ==2 || scope.row.containerState ==3 || scope.row.containerState ==11) && getGenerateInvoiceData(scope.row.generateInvoiceData).status == 2" @click="downInvoice(getGenerateInvoiceData(scope.row.generateInvoiceData).url)">
                  下载发票
                </el-button>
                <el-button v-if="scope.row.containerState == 3" class="list-btn-four btn-blue" @click="handleSend(scope.row)">
                  发货
                </el-button>
              </div>
              <!-- 发票 -->
              <div v-else-if="item.key === 'invoiceUrl'">
                <el-upload action="/" :file-list="fileList" :http-request="(file)=> uploadVideo(scope.row.containerBatchNo,scope.row.containerState,file)"
                  accept=".pdf,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" :limit='1' :show-file-list='false'>
                  <el-button class="list-btn btn-blue" ref='uploadVideo'>上传
                  </el-button>
                </el-upload>
                <div>
                  <el-button class="list-btn btn-red" v-if="scope.row.invoiceUrl" @click="delInvoiceUrl(scope.row)">删除
                  </el-button>
                </div>
                <a class="link" @click="downloadFile(scope.row)">{{ scope.row.invoiceFilename }}</a><br>
                <el-popover
                  v-if="scope.row.invoiceUrl && scope.row.logisticsCompanySign == 'sf'"
                  placement="top"
                  width="214"
                  >
                  <div style="text-align: right; margin: 0">
                    <el-button type="success" style="background-color: #6fad7c; border: 0;" size="mini" @click="SFbox(scope.row,'sfdb')">顺丰大包</el-button>
                    <el-button type="success" style="background-color: #6fad7c; border: 0;" size="mini" @click="SFbox(scope.row,'sfxb')">顺丰小包</el-button>
                  </div>
                  <el-button class="list-btn btn-yellow" slot="reference">导出</el-button>
                </el-popover>
              </div>
              <!-- 输入许可书 -->
              <div v-else-if="item.key === 'permitBook' && scope.row.containerState == 4">
                <el-upload action="/" :file-list="fileList" :http-request="(file)=> uploadLicence(scope.row.containerBatchNo,scope.row.containerState,file)"
                  accept=".pdf" :limit='1' :show-file-list='false'>
                  <el-button class="list-btn btn-blue" ref='uploadLicence'>上传
                  </el-button>
                </el-upload>
                <div>
                  <el-button class="list-btn btn-red" v-if="scope.row.licenceUrl" @click="dellicenceUrl(scope.row)">删除
                  </el-button>
                </div>
                <a class="link" @click="downloadlicenceFile(scope.row)">{{ scope.row.licenceFilename }}</a><br>
              </div>
              <!-- 用户ID -->
              <div v-else-if="item.key === 'userName'" class="userName">
                  <p>{{ scope.row.userName }}</p>
                  <p v-if="scope.row.remarkCustomerName">{{ scope.row.remarkCustomerName }}</p>
              </div>
              <!--员工附件-->
              <div v-else-if="item.key === 'operatorAttachment'">
                <el-upload action="/" :http-request="(file) =>uploadAttachment(file,scope.row)"
                  :before-upload="(file)=>beforeUploadFile(file,scope.row.attachment)" :show-file-list="false">
                  <el-button class="list-btn btn-blue" ref="uploadAttachment">上传</el-button>
                </el-upload>
                <template v-for="(item,i) in getAttachment(scope.row.attachment)">
                  <el-tag v-if="item.operatorDelete == undefined || item.operatorDelete == 0" :key="i" :closable="true" size="medium"
                    @click="viewAttachment(item)" @close="deleteAttachment(item,scope.row)"
                    style="display: block;height: auto;text-align: left;white-space: normal;margin-top: 5px;cursor: pointer;">
                    {{item.name}}
                  </el-tag>
                </template>
              </div>

              <!--客户附件-->
              <div v-else-if="item.key === 'attachment'">
                <template v-for="(item,i) in getAttachment(scope.row.attachment)">
                  <el-tag v-if="(item.type == undefined || item.type == 0) && (item.customerDelete == undefined || item.customerDelete == 0)" :key="i"
                    size="medium" @click="viewAttachment(item)"
                    style="display: block;height: auto;text-align: left;white-space: normal;margin-top: 5px;cursor: pointer;">
                    {{item.name}}
                  </el-tag>
                </template>
              </div>

              <!-- 装箱批次号 -->
              <div v-else-if="item.key === 'containerBatchNo'">
                <div >{{scope.row.containerBatchNo}}</div>
<!--                <el-button :class="scope.row.profitRate >= maxProfitRate ?  'list-btn-four  btn-red' : 'list-btn-four  btn-blue' "
                           v-if="scope.row.containerState ==1
                           || scope.row.containerState ==2
                           || scope.row.containerState ==3
                           || scope.row.containerState ==4
                           || scope.row.containerState == 11"
                           @click="showProfitRate(scope.row.containerBatchNo)" style="margin-top: 8px;width: 95px">利润率<span v-if="scope.row.profitRate > 0">:{{scope.row.profitRate}} </span>
                </el-button>-->
              </div>
              <!-- 创建日期 -->
              <div v-else-if="item.key === 'createTime'">
                {{scope.row.createTime|formatDateFilter}}
              </div>
              <!-- 状态 -->
              <div v-else-if="item.key === 'containerState'">
                <div v-for="(item,i) in containerStateList" :key="i">
                  <div v-if="scope.row.containerState==item.value">
                    {{ item.label }}
                  </div>
                </div>
              </div>
              <!-- 发送日 -->
              <div v-else-if="item.key === 'sendTime'">
                {{scope.row.sendTime | formatDateFilter}}
<!--                <el-button v-if="scope.row.containerState==4" @click="handleStorage(scope.row)" class="list-btn-four btn-blue">仓储费明细</el-button>-->
              </div>
              <!-- 物流信息 -->
              <div v-else-if="item.key === 'logisticeCompany'">
                <div class="overflowDot" :title="scope.row.logisticeCompany">{{scope.row.logisticeCompany}}</div>
                <div v-if="checkWl(scope.row)">{{ scope.row.waybillNumber }}
                  <el-popover @show="getTrach(scope.row, false)" :width="500" trigger="click" placement="left">
                    <template>
                      <p style="padding-bottom: 5px;border-bottom: 1px solid #ccc; width: 100%; overflow: hidden;">运单号{{scope.row.waybillNumber}}
                        <span v-if="tractData && tractData.length> 0">
                          <!-- <el-tag type="primary" style="font-size: 10.8px;">{{ tractData[0].trackingDetail}}</el-tag> -->
                          <div style="width: 470px; overflow-wrap:break-word; color: #409eff;">{{ tractData[0].trackingDetail}}</div>
                        </span>
                      </p>
                      <div style="max-height: 370px; overflow-y: auto;" >
                        <div style="margin: 5px 0" v-for="(item, index) in tractData" :key="index">
                          <span>{{ item.checkpointDate }}</span>
                          <span style="margin-left: 5px;" v-html="item.trackingDetail"></span>
                          <span style="margin-left: 5px;" v-html="item.location"></span>
                        </div>
                        <span>{{tractMsg}}</span>
                      </div>
                    </template>
                    <i slot="reference" class="el-icon-question" style="cursor: pointer"></i>
                  </el-popover>
                </div>
                <div v-else>
                  <span v-if="!!scope.row.waybillNumber">{{ scope.row.waybillNumber }}</span>
                </div>
                <div v-if="!!scope.row.transBillid">
                  {{ scope.row.transBillid }}
                  <el-popover @show="getTrach(scope.row, true)" :width="500" trigger="click" placement="left">
                    <template>
                      <p style="padding-bottom: 5px;border-bottom: 1px solid #ccc; width: 100%; overflow: hidden;">运单号{{scope.row.transBillid}}
                        <span v-if="tractData && tractData.length> 0">
                          <!-- <el-tag type="primary" style="font-size: 10.8px;">{{ tractData[0].trackingDetail}}</el-tag> -->
                          <div style="width: 470px; overflow-wrap:break-word; color: #409eff;">{{ tractData[0].trackingDetail}}</div>
                        </span>
                      </p>
                      <div style="max-height: 370px; overflow-y: auto;" >
                        <div style="margin: 5px 0" v-for="(item, index) in tractData" :key="index">
                          <span>{{ item.checkpointDate }}</span>
                          <span style="margin-left: 5px;" v-html="item.trackingDetail"></span>
                          <span style="margin-left: 5px;" v-html="item.location"></span>
                        </div>
                        <span>{{tractMsg}}</span>
                      </div>
                    </template>
                    <i slot="reference" class="el-icon-question" style="cursor: pointer"></i>
                  </el-popover>
                </div>
<!--                <div v-html="scope.row.logisticeState"></div>-->
                <!--                <span v-if="scope.row.sagawa === '1'">-->
                <!--                  <a target="_blank"-->
                <!--                    :href="'http://k2k.sagawa-exp.co.jp/p/web/okurijosearch.do?okurijoNo=' + scope.row.waybillNumber">{{scope.row.waybillNumber}}</a>-->
                <!--                </span>-->
                <!--                <span v-else>-->
                <!--                  {{scope.row.waybillNumber}}-->
                <!--                </span>-->
                <!--                <div v-html="scope.row.logisticeState"></div>-->
              </div>
              <!-- 收件信息 -->
              <div v-else-if="item.key === 'recipientName'" class="recipientName">
                <!-- <div class="overflowDot" :title="scope.row.logisticeCompany">{{scope.row.logisticeCompany}}</div> -->
                <!-- <div>{{scope.row.recipientName}}</div>
                <div>{{scope.row.zipCode}}</div>
                <div>{{scope.row.deliveryAddress}}</div> -->

                <el-form label-position="right" label-width="56px" :model="scope.row" size="mini">
                  <el-form-item label="收件人：">
                    <span style="display: block; width: 100%; text-align: left;">{{ scope.row.recipientName }}</span>
                  </el-form-item>
                  <el-form-item label="手机号：">
                    <span style="display: block; width: 100%; text-align: left;">{{ scope.row.deliveryPhone }}</span>
                  </el-form-item>
                  <el-form-item label="邮编：">
                    <span style="display: block; width: 100%; text-align: left;">{{ scope.row.zipCode }}</span>
                  </el-form-item>
                  <el-form-item label="地址：">
                    <span style="display: block; width: 100%; text-align: left;">{{scope.row.sendArea}}{{scope.row.deliveryAddress}}</span>
                  </el-form-item>
                </el-form>

                <!-- <div class="font-style1">
                  <span class="left">收件人</span>
                  <span>：</span>
                  <span class="right">{{scope.row.recipientName}}</span>
                </div>
                <div class="font-style1">
                  <span class="left">&nbsp;&nbsp;&nbsp;邮编</span>
                  <span>：</span>
                  <span class="right">{{scope.row.zipCode}}</span>
                </div>
                <div class="font-style1">
                  <span class="left">&nbsp;&nbsp;&nbsp;地址</span>
                  <span>：</span>
                  <span class="right">{{scope.row.sendArea}}{{scope.row.deliveryAddress}}</span>
                </div> -->


                <!-- <div class="overflowDot" :title="scope.row.logisticeState">{{scope.row.logisticeState}}</div> -->
              </div>
              <div v-else-if="item.key === 'route'">
                {{scope.row.route === '1' ? "空运": "海运"}}
              </div>
              <!-- 进口商信息 -->
              <div v-else-if="item.key === 'senderAddress'">
                <!-- <div class="overflowDot" :title="scope.row.logisticeCompany">{{scope.row.logisticeCompany}}</div> -->
                <!-- <div>{{scope.row.recipientName}}</div>
                <div>{{scope.row.zipCode}}</div>
                <div>{{scope.row.deliveryAddress}}</div> -->


                <el-form label-position="right" label-width="56px" :model="scope.row" size="mini">
                  <el-form-item label="进口商：">
                    <span style="display: block; width: 100%; text-align: left;">{{ scope.row.senderName }}</span>
                  </el-form-item>
                  <el-form-item label="邮编：">
                    <span style="display: block; width: 100%; text-align: left;">{{ scope.row.senderZipCode }}</span>
                  </el-form-item>
                  <el-form-item label="地址：">
                    <span style="display: block; width: 100%; text-align: left;">{{scope.row.senderAddress}}</span>
                  </el-form-item>
                </el-form>


                <!-- <div class="font-style1">
                  <span class="left">进口商</span>
                  <span>：</span>
                  <span class="right">{{scope.row.senderName}}</span>
                </div>
                <div class="font-style1">
                  <span class="left">邮编</span>
                  <span>：</span>
                  <span class="right">{{scope.row.senderZipCode}}</span>
                </div>
                <div class="font-style1">
                  <span class="left">地址</span>
                  <span>：</span>
                  <span class="right">{{scope.row.senderAddress}}</span>
                </div> -->

                <!-- <div class="overflowDot" :title="scope.row.logisticeState">{{scope.row.logisticeState}}</div> -->
              </div>
              <div v-else-if="item.key === 'comments'">
                <span>{{scope.row.comments}}</span>
              </div>
              <!-- 工作签 -->
              <div v-else-if="item.key === 'remark'">
                <el-input type="textarea" rows="5" maxlength="200" @change="quickSave(scope.row.remark,'0',scope.row.id)" placeholder="请输入工作签"
                  v-model="scope.row.remark" size="small">
                </el-input>
              </div>
              <!--YFF/RSL/FBA/ZOZO-->
              <div v-else-if="item.key === 'containerOrderType'">
                <el-select v-model="scope.row.containerOrderType" placeholder="请选择" size="small" :disabled="handleChangeState(scope.row.containerState)"
                  @change="containerStateAlter(scope.row)">
                  <el-option v-for="(item,index) in fbaOptions" :key="index" :label="item.name" :value="item.value"></el-option>
                </el-select>
                <!--v-if="scope.row.containerOrderType != '1'"-->
                <el-input type="textarea" rows="5" maxlength="200" @change="quickSave(scope.row.containerOrderContent,'2',scope.row.id)"
                  :disabled="handleChangeState(scope.row.containerState)" placeholder="请输入提示内容" v-model="scope.row.containerOrderContent"
                  size="small"></el-input>
              </div>
              <div v-else-if="item.key === 'realWeight'" class="recipientName">

                <el-form label-position="right" label-width="56px" :model="scope.row" size="mini">
                  <el-form-item label="总实重：">
                    <span style="display: block; width: 100%; text-align: left;">{{ scope.row.realWeight }}</span>
                  </el-form-item>
                  <el-form-item label="总抛重：">
                    <span style="display: block; width: 100%; text-align: left;">{{ scope.row.throwWeight }}</span>
                  </el-form-item>
                </el-form>
              </div>
              <!-- 其他不需要处理的 -->
              <span v-else>
                {{scope.row[item.key]}}
              </span>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="employeeRemark" align="center" label="员工备注" width="80"></el-table-column> -->

        </el-table>
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="queryInfo.pageNum"
          :page-sizes="[5, 10, 20, 50, 100, 200]" :page-size="queryInfo.pageSize" layout="total, sizes, prev, pager, next, jumper"
          :total="total"></el-pagination>
      </div>
    </tableCon>
    <!-- 装箱单编辑弹框 -->
    <el-dialog :visible.sync="ContainerOrderListVisible" width="70%" title="编辑装箱单" @close="splitDialogClosed">
      <el-table :data="containerOrderList" :header-cell-style="tableStyle.headerStyle" @selection-change="handleOrderSelectionChange" border stripe
        style="width: 100%" class="container-order-list" :height="460">
        <el-table-column type="selection" :selectable="checkboxSelect" width="55" fixed="left"></el-table-column>
        <el-table-column type="index" align="center" label="序号" width="40" fixed="left"></el-table-column>
        <el-table-column prop="orderId" align="center" label="订单编号" width="70" fixed="left">
          <template slot-scope="scope">
            <el-image v-if="scope.row.goodsPlatform === '1688'" class="tagImg" :src="img1688" fit="contain" />
            <el-image v-if="scope.row.goodsPlatform === 'goodfish'" class="tagImg" :src="imgTb" fit="contain" />
            <br>
            <span>{{scope.row.orderId}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="goodsNameCn" label="商品名" min-width="200" fixed="left">
          <template slot-scope="scope">
            <div>{{scope.row.goodsNameCn || scope.row.goodsName}}</div>
          </template>
        </el-table-column>
        <el-table-column label="图片" align="center" width="115" fixed="left">
          <template slot-scope="scope">
            <img @click="imgclick(scope.row.pictureUrl,true)" v-if="scope.row.pictureUrl&&scope.row.pictureUrl.length>0" :src="scope.row.pictureUrl" alt=""
              class="list-image" style="width: 100px;height: 100px;">
            <img v-else src="../../assets/images/default.png" alt="" class="list-image" style="width: 100px;height: 100px;">
            <!--<img :src="scope.row.badPicture1" alt="" style="width: 100px;height: 100px;">-->
          </template>
        </el-table-column>
        <!-- <el-table-column v-if="curContainerState != 10 && curContainerState != 0 && curContainerState != 7 && curContainerState != 5" prop="price" label="价格" width="90" fixed="left"></el-table-column> -->
        <!-- <el-table-column prop="orderType" label="FBA/YFF/ZOZO/RSL" width="90">
          <template slot-scope="scope">
            <div>{{ scope.row.orderType | isFBA }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="fnsku" label="编号" width="90"></el-table-column>
        <el-table-column prop="asin" label="ASIN" width="90"></el-table-column> -->
        <el-table-column prop="canApplyCount" align="center" label="可申请数" width="90"></el-table-column>
        <template v-if="curContainerState == 0 || curContainerState == 6 || curContainerState == 7 || curContainerState == 10">
          <el-table-column align="center" label="申请数量" min-width="130">
            <template v-slot="scope">
              <el-input-number clearable v-model="scope.row.containerGoodsCount" :max="scope.row.maxCount" :min="1" size="small" style="width: 100px">
              </el-input-number>
            </template>
          </el-table-column>
          <el-table-column align="center" label="删除" width="90">
            <template v-slot="scope">
              <div class="btn-row">
                <el-button type="primary" plain @click="delGooods(scope.row)" size="mini">删除</el-button>
              </div>
            </template>
          </el-table-column>
        </template>
        <template v-else>
          <el-table-column align="center" label="申请数量" min-width="130">
            <template v-slot="scope">
              {{scope.row.containerGoodsCount}}
            </template>
          </el-table-column>
        </template>
        <el-table-column prop="goodsNameCus" label="品名" min-width="200">
          <template v-slot="scope">
            <el-input type="textarea" placeholder="" v-model="scope.row.goodsNameCus" size="small" disabled>
            </el-input>
          </template>
        </el-table-column>
        <el-table-column prop="orderStatus" align="center" label="订单状态" width="90">
          <template v-slot="scope">
            <span v-if="scope.row.isAppendage == '1'" style="color: red">附属品</span>
            <span v-else>{{ scope.row.orderStatus | orderStatusFilter(scope.row.goodsPlatform) }}</span>
          </template>
        </el-table-column>

        <el-table-column prop="staffRemark" align="center" label="采购工作签" width="90">
          <template v-slot="scope">
            {{scope.row.staffRemark}}
          </template>
        </el-table-column>

        <el-table-column prop="checkRemark" align="center" label="检品" width="90">
          <template v-slot="scope">
            <span v-if="scope.row.inspection&&scope.row.inspection.length>0">
              <div v-for="item in scope.row.inspection.split(',')" :key="item">
                {{item}}
              </div>
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="checkRemark" align="center" label="检品工作签" width="90">
          <template v-slot="scope">
            {{scope.row.checkRemark}}
          </template>
        </el-table-column>

        <!-- <el-table-column prop="categoryFlag" align="center" label="仓库保管" width="90">
          <template slot-scope="scope">
            <div>{{ scope.row.categoryFlag == 0 ? "否" : "是"}}</div>
          </template>
        </el-table-column> -->
        <!--        <el-table-column prop="goodsCount" align="center" label="商品数量" width="120"></el-table-column>-->
        <!--        <el-table-column prop="refundCount" align="center" label="退货数量" width="90"></el-table-column>-->
        <!--        <el-table-column prop="destroyCount" align="center" label="销毁数量" width="90"></el-table-column>-->
        <el-table-column prop="totalNetWeight" align="center" label="净重" width="90">
          <template v-slot="scope">
            <div>
              {{scope.row.totalNetWeight != null ? scope.row.totalNetWeight.toFixed(3):''}}
            </div>
          </template>
        </el-table-column>
        <el-table-column align="center" label="本批次已装箱数量" min-width="130">
          <template v-slot="scope">
            {{scope.row.containerGoodsCountInstalled}}
          </template>
        </el-table-column>
        <el-table-column prop="configLocator" align="center" label="库位" width="90"></el-table-column>
        <el-table-column prop="boxNum" align="center" label="箱号" width="100">
          <template v-slot="scope">
            <div v-for="(vv,index) in scope.row.newBoxNum" :key="index">
              {{vv}}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="goodsNumber" align="center" label="商品SKU" width="100"></el-table-column>
        <el-table-column prop="colourCn" align="center" label="颜色" width="90"></el-table-column>
        <el-table-column prop="goodsSizeCn" align="center" label="尺寸" width="90"></el-table-column>
      </el-table>
      <!-- </div>  -->
      <span slot="footer" class="dialog-footer dialog-action">
        <div>
          <el-tag v-if="curContainerState != 0 && curContainerState != 7 && curContainerState != 5">商品总价格：{{ pricetotal }}</el-tag>
        </div>
        <div>
          <template v-if="curContainerState == 0 || curContainerState == 6 || curContainerState == 7 || curContainerState == 10">
            <el-button v-if="curContainerState == 6" class="form-btn btn-green" @click="transferOrder"
              :disabled="transferInfo.containerOrderIdList.length <= 0">转移订单</el-button>
            <el-button class="form-btn btn-green" @click="addGoodsVisiable = true">新增商品</el-button>
            <el-button class="form-btn btn-red" @click="appendageVisiable = true">附属品</el-button>
            <el-button class="form-btn btn-blue" @click="onSave()">保存</el-button>
          </template>
          <el-button
            class="form-btn btn-blue"
            style="margin-right:15px"
            v-if="curContainerState != 6 && curContainerState != 5 && curContainerState != 0 && curContainerState != 10"
            @click="handleExportBoxWrapDetail">
            运输箱包装明细
          </el-button>
          <el-button class="form-btn  btn-blue" v-if="customerBox.boxStatus === '0'" key="0" style="margin-right:15px" @click="handleExport">导出</el-button>
          <el-button class="form-btn" v-if="customerBox.boxStatus === '1'" key="1" type="danger" style="margin-right:15px" readonly loading>下载中</el-button>
          <el-button class="form-btn" v-if="customerBox.boxStatus === '2'" key="2" type="success" style="margin-right:15px"
            @click="handleExportEndBoxDetail(customerBox.boxUrl)" icon="el-icon-download">下载完毕</el-button>
          <el-button class="form-btn btn-gray" @click="ContainerOrderListVisible = false">关闭</el-button>
        </div>
      </span>
    </el-dialog>

    <!--    图片放大-->
    <el-dialog title="" :visible.sync="visible" width="30%" show-close center>
      <img width="100%" height="auto" :src="imgurl" alt="" class="list-image">
      <!--    <img :src="this.$store.state.imgurl" alt="">-->
    </el-dialog>
    <lx-sort :visible.sync="isVisibleSort" :list="columns" @confirm="doSaveColumns"></lx-sort>

    <!-- 修改页面 -->
    <el-dialog :visible.sync="ModifyPageVisible" width="61%" title="修改装箱单" @close="ModifyPageClosed">
      <el-form :model="ModifyContainerOrderInfo" :rules="rules" ref="dialogForm" class="demo-userInfo">
        <el-form-item label="装箱批次号:" label-width="120px">
          <!-- <div class="query-title" style="width: 250px">装箱批次号:{{ModifyContainerOrderInfo.containerBatchNo}}</div> -->
          <el-input v-model="ModifyContainerOrderInfo.containerBatchNo" style="width: 200px" size="small" disabled></el-input>
        </el-form-item>
<!--        <el-row class="search-row" style="width: 1500px">
          <el-col :span="7" class="display-row">
            <el-form-item label="进口商:" prop="senderName" label-width="120px">
              <el-input v-model="ModifyContainerOrderInfo.senderName" style="width: 200px" size="small"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="7" class="display-row">
            <el-form-item label="进口商电话：" prop="senderPhone" label-width="120px">
              <el-input v-model="ModifyContainerOrderInfo.senderPhone" style="width: 200px" size="small"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row class="search-row" style="width: 1500px">
          <el-col :span="7" class="display-row">
            <el-form-item label="进口商地区：" prop="addresserArea" label-width="120px">
              <el-input v-model="ModifyContainerOrderInfo.addresserArea" style="width: 200px" size="small"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="7" class="display-row">
            <el-form-item label="进口商地址：" prop="senderAddress" label-width="120px">
              <el-input v-model="ModifyContainerOrderInfo.senderAddress" style="width: 200px" size="small"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row class="search-row" style="width: 1500px">
          <el-col :span="7" class="display-row">
            <el-form-item label="进口商邮编：" prop="senderZipCode" label-width="120px">
              <el-input v-model="ModifyContainerOrderInfo.senderZipCode" style="width: 200px" size="small"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="7" class="display-row">
            <el-form-item label="进口商Email：" prop="senderEmail" label-width="120px">
              <el-input v-model="ModifyContainerOrderInfo.senderEmail" style="width: 200px" size="small"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row class="search-row" style="width: 1500px">
          <el-col :span="7" class="display-row">
            <el-form-item label="法人编号：" prop="senderLegalNo" label-width="120px">
              <el-input v-model="ModifyContainerOrderInfo.senderLegalNo" style="width: 200px" size="small"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="7" class="display-row">
            <el-form-item label="Naccs账户：" prop="senderNaccsAccount" label-width="120px">
              <el-input v-model="ModifyContainerOrderInfo.senderNaccsAccount" style="width: 200px" size="small"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row class="search-row" style="width: 1500px">
          <el-col :span="7" class="display-row">
            <el-form-item label="公司名称：" prop="senderCompanyName" label-width="120px">
              <el-input v-model="ModifyContainerOrderInfo.senderCompanyName" style="width: 200px" size="small"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="7" class="display-row">
          </el-col>
        </el-row>-->
        <el-row class="search-row" style="width: 1500px">
          <el-col :span="7" class="display-row">
            <el-form-item label="收件人：" prop="recipientName" label-width="120px">
              <el-input v-model="ModifyContainerOrderInfo.recipientName" style="width: 200px" size="small"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="7" class="display-row">
            <el-form-item label="收件人电话：" prop="deliveryPhone" label-width="120px">
              <el-input v-model="ModifyContainerOrderInfo.deliveryPhone" style="width: 200px" size="small"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row class="search-row" style="width: 1500px">
          <el-col :span="7" class="display-row">
            <el-form-item label="收件地区：" prop="sendArea" label-width="120px">
              <el-input v-model="ModifyContainerOrderInfo.sendArea" style="width: 200px" size="small"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="7" class="display-row">
            <el-form-item label="收件地址：" prop="deliveryAddress" label-width="120px">
              <el-input v-model="ModifyContainerOrderInfo.deliveryAddress" style="width: 200px" size="small"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row class="search-row" style="width: 1500px">
          <el-col :span="7" class="display-row">
            <el-form-item label="收件人邮编：" prop="zipCode" label-width="120px">
              <el-input v-model="ModifyContainerOrderInfo.zipCode" style="width: 200px" size="small"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="7" class="display-row">
          </el-col>
        </el-row>
        <!-- <el-row class="search-row" style="width: 1500px">
          <el-col :span="7" class="display-row">
            <el-form-item label="EMAIL：" prop="emailAddress" label-width="120px">
              <el-input v-model="ModifyContainerOrderInfo.emailAddress" style="width: 200px" size="small"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="7" class="display-row">
            <el-form-item label="进口商编码：" prop="importCode " label-width="120px">
              <el-input v-model="ModifyContainerOrderInfo.importCode" style="width: 200px" size="small"></el-input>
            </el-form-item>
          </el-col>
        </el-row> -->
        <el-row class="search-row" style="width: 1500px">
          <el-col :span="7" class="display-row">
            <el-form-item label="线路：" prop="route" label-width="120px">
              <el-select v-model="ModifyContainerOrderInfo.route" placeholder="请选择" size="small" clearable @change='routeChange'>
                <el-option v-for="item in routeList" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>

            </el-form-item>
          </el-col>
          <el-col :span="7" class="display-row">
            <el-form-item label="物流公司：" prop="logisticsCompanyId" label-width="120px">

              <el-select v-model="ModifyContainerOrderInfo.logisticsCompanyId" placeholder="请选择" size="small" clearable>
                <el-option v-for="item in dropDownListEdit" :key="item.id" :label="item.companyName" :value="item.id">
                </el-option>
              </el-select>

            </el-form-item>
          </el-col>
          <!--  <el-col :span="7" class="display-row">
            <el-form-item label="发送地区：" prop="sendArea" label-width="120px">
              <el-input v-model="ModifyContainerOrderInfo.sendArea" style="width: 200px" size="small"></el-input>
            </el-form-item>
          </el-col> -->
        </el-row>
        <el-row class="search-row" style="width: 1500px">
          <el-col :span="7" class="display-row">
            <el-form-item label="运单号：" prop="waybillNumber" label-width="120px">
              <el-input v-model="ModifyContainerOrderInfo.waybillNumber" style="width: 200px" size="small"></el-input>
            </el-form-item>
          </el-col>
          <el-col v-if="ModifyContainerOrderInfo.waybillNumber?.indexOf('SF') > -1" :span="7" class="display-row">
            <el-form-item label="转运单号：" prop="transBillid" label-width="120px">
              <el-input v-model="ModifyContainerOrderInfo.transBillid" style="width: 200px" size="small"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row class="search-row" style="width: 1500px">
<!--          <el-col :span="7" class="display-row">
            <el-form-item label="FBA/YFF/ZOZO/RSL：" prop="containerOrderType" label-width="160px">
              <el-select v-model="ModifyContainerOrderInfo.containerOrderType" placeholder="请选择" size="small"
                :disabled="handleChangeState(ModifyContainerOrderInfo.containerState)">
                <el-option v-for="(item,index) in fbaOptions" :key="index" :label="item.name" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </el-col>-->

          <el-col :span="7" class="display-row">
            <el-form-item label="提醒内容：" prop="containerOrderContent" label-width="120px"
              v-if="ModifyContainerOrderInfo.containerOrderType != '1' && !handleChangeState(ModifyContainerOrderInfo.containerState)">
              <el-input v-model="ModifyContainerOrderInfo.containerOrderContent" :disabled="handleChangeState(ModifyContainerOrderInfo.containerState)"
                size="small"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row class="search-row" tyle="width: 1500px">
          <el-col :span="7" class="display-row">
            <el-form-item label="备注：" prop="comments" label-width="120px">
              <el-input v-model="ModifyContainerOrderInfo.comments" disabled style="width: 650px;"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button class="form-btn btn-gray" @click="ModifyPageVisible = false">取 消</el-button>
        <el-button class="form-btn btn-blue" @click="replySave" type="primary">提 交</el-button>
      </span>
    </el-dialog>

    <!-- 转移批次内订单 -->
    <el-dialog title="转移订单" :visible.sync="transferVisiable" width="30%">
      <el-form :model="transferInfo" :rules="rules" ref="boxInfo" label-width="120px" class="demo-boxInfo">
        <el-form-item label="目标批次" prop="targetContainerBatchNo">
          <el-select v-model="transferInfo.toContainerBatchNo" filterable placeholder="请选择" size="small" clearable>
            <el-option v-for="item in containerOptions" :key="item.containerBatchNo" :label="item.containerBatchNo" :value="item.containerBatchNo"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="transferVisiable = false" class="form-btn btn-gray">取 消</el-button>
        <el-button @click="saveTransfer" :disabled="transferInfo.toContainerBatchNo==''" class="form-btn btn-blue">提 交</el-button>
      </div>
    </el-dialog>
    <el-dialog title="仓储费明细" :visible.sync="storageSync" width="70%">
      <p style="margin:-30px 0 20px 0;display: flex;justify-content: flex-end;">批次仓储费用合计（￥）：{{ totalCategoryPrice }}</p>
      <el-table :data="storageList" style="width: 100%" border :header-cell-style="tableStyle.headerStyle">
        <el-table-column type="index" label="序号" width="80" align="center">
        </el-table-column>
        <el-table-column prop="boxNo" label="箱号" width="120" align="center">
        </el-table-column>
        <el-table-column prop="orderId" label="订单编号" width="120" align="center">
        </el-table-column>
        <el-table-column prop="goodsName" label="商品名" width="150">
        </el-table-column>
        <el-table-column prop="boxGoodsCount" label="数量(件)" align="center">
        </el-table-column>
        <el-table-column prop="showAbnormalOrder" label="异常单号/原因/方案" width="90" align="center">
          <template #default="{row}">{{ row.showAbnormalOrder=='否'?'否':row.showAbnormalOrder }}</template>
        </el-table-column>
        <el-table-column prop="freeWarehousing" label="是否免仓储费" width="100" align="center">
          <template #default="{row}">{{ row.freeWarehousing==0?'否':'是' }}</template>
        </el-table-column>
        <el-table-column prop="inLibraryTime" label="仓储开始时间" width="100" align="center">
        </el-table-column>
        <el-table-column prop="startChargingTime" label="计费开始时间" width="100" align="center">
        </el-table-column>
        <el-table-column prop="sendTime" label="发送时间" width="100" align="center">
        </el-table-column>
        <el-table-column prop="dayDifference" label="仓储时长(天)" width="100" align="center">
        </el-table-column>
        <el-table-column prop="categoryPrice" label="仓储费小计(￥)" width="110" align="center">
          <template #default="{row}">{{ row.categoryPrice || 0}}</template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button class="form-btn  btn-blue" key="0" style="margin-right:15px" @click="storageExport">导出</el-button>
        <el-button class="form-btn btn-blue" @click="storageSync = false">确定</el-button>
      </div>
    </el-dialog>
    <el-dialog
        title="利润率"
        :visible.sync="profitRateVisible"
        width="460px"
        center
    >
      <p style="font-weight: bold; ">
      下記はお客様のご注文に基づく当社の推定利益率です。<br />
      下記の金額は振込金額ではありませんので、振込しないようお気を付け下さい！<br />
      ありがとうございました。
    </p>
      <br>
      <h3>注文番号：{{profitRateObj.batchNo }}</h3>

      <el-row style="margin: 10px;">
        <el-col :span="16" class="label">注文金額(円):</el-col>
        <el-col :span="8" class="value">{{format_with_substring(profitRateObj.ordersAmountJp) }}円</el-col>
      </el-row>
      <el-row style="margin: 10px;">
        <el-col :span="16" class="label">国際送料(円)：</el-col>
        <el-col :span="8" class="value">{{format_with_substring(profitRateObj.freightAmountJp) }}円</el-col>
      </el-row>
      <el-row style="margin: 10px;">
        <el-col :span="16" class="label">合計：</el-col>
        <el-col :span="8" class="value">{{format_with_substring(profitRateObj.totalAmountJp) }}円</el-col>
      </el-row>
      <el-row style="margin: 10px;">
        <el-col :span="16" class="label">商品金額(円)：</el-col>
        <el-col :span="8" class="value">{{format_with_substring(profitRateObj.goodsAmountJp) }}円</el-col>
      </el-row>
<!--      <el-row style="margin: 10px;">-->
<!--        <el-col :span="16" class="label">為替レート：</el-col>-->
<!--        <el-col :span="8" class="value">1元＝{{format_with_substring(profitRateObj.exchangeRate) }}円</el-col>-->
<!--      </el-row>-->
      <el-row style="margin: 10px;">
        <el-col :span="16" class="label">商品金額(元)：</el-col>
        <el-col :span="8" class="value">{{format_with_substring(profitRateObj.goodsAmount) }}元</el-col>
      </el-row>
      <el-row style="margin: 5px 10px;">
        <el-col :span="16" class="label">支払総額(円)÷商品金額(元)：</el-col>
        <el-col :span="8" class="value" style="color: rgb(255, 105, 31); ">{{format_with_substring(profitRateObj.profitRate) }}</el-col>
      </el-row>
      <div class="dialog-footer" style="display: flex; justify-content: center;">
        <el-button class="form-btn btn-red" style="margin-top: 16px" @click="profitRateVisible = false">关闭</el-button>
      </div>
    </el-dialog>
    <lx-sort :visible.sync="isVisibleSort" :list="columns" @confirm="doSaveColumns"></lx-sort>

    <SelectGoods :isVisiable.sync="addGoodsVisiable" :selectedList="containerOrderList" :userId="curUserId" @confirm="onConfirm"></SelectGoods>

    <AppendageSelectGoods :isVisiable.sync="appendageVisiable" :userId="curUserId" @confirm="onAppendageConfirm"></AppendageSelectGoods>

    <!-- <MessageTip :visiable.sync="replyMessageVisiable" :userName="replyMessageInfo.userName" messageType="批次消息"
                :orderNo="replyMessageInfo.containerBatchNo" httpUrl="cms/inBox/remind" @confirm="onConfirmMsg"></MessageTip> -->
    <MessageTip :visiable.sync="replyMessageVisiable" :info="replyMessageInfo" @confirm="onConfirmMsg"></MessageTip>

    <!-- 发货 -->
    <el-dialog
        title=""
        :visible.sync="yesVisible"
        width="40%"
        show-close
        :destroy-on-close="true"
        @close="yesDialogClose"
        center
    >
      <el-form
          :model="yseInfo"
          :rules="yseRules"
          ref="yseInfo"
          label-width="120px"
          class="demo-replyInfo"
      >
        <el-form-item label="物流公司:" prop="logisticsCompanyId">
          <el-select
              v-model="yseInfo.logisticsCompanyId"
              @change="updateSelect"
              placeholder="请选择"
              size="small"
              clearable
          >
            <el-option
                v-for="item in dropDownList"
                :key="item.id"
                :label="item.companyName"
                :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="运单号:" prop="waybillNumber" style="margin-top: 20px;">
          <el-input size="small" maxlength="50" v-model="yseInfo.waybillNumber"></el-input>
        </el-form-item>
      </el-form>
      <div style="text-align: right;margin-top: 20px;">
        <el-button class="form-btn btn-gray" @click="yesDialogClose">取 消</el-button>
        <el-button class="form-btn btn-blue" @click="yesSave('yseInfo')">提 交</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { columns as originColumns } from "./containerColumns"
import { filterList } from "@/assets/js/utils"
import LxSort from "@/components/LxSort/index"
import tableCon from "../../views/tableContainer"
import SelectGoods from "./cmp/SelectGoods"
import AppendageSelectGoods from "./cmp/AppendageSelectGoods"
import MessageTip from '@/components/MessageTip/index'
import { number } from "echarts/lib/export"
import img1688 from "@/assets/images/1688.png";
import imgTb from "@/assets/images/tb.png";

export default {
  name: 'container',
  components: {
    LxSort,
    tableCon,
    SelectGoods,
    MessageTip,
    AppendageSelectGoods
  },
  data () {
    // 自定义邮箱校验规则
    var checkEmail = (rule, value, cb) => {
      const regEail = /^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,4}$/
      if (regEail.test(value)) {
        return cb()
      }
      cb(new Error("请输入合法的邮箱"))
    }
    // 自定义手机号校验规则
    var checkMobile = (rule, value, cb) => {
      const regMobile = /^[1][2,3,4,5,6,7,8,9][0-9]{9}$/
      if (regMobile.test(value)) {
        return cb()
      }
      cb(new Error("请输入合法的手机号"))
    }
    return {
      img1688,
      imgTb,
      pricetotal:0,
      transferInfo: {
        oldContainerBatchNo: '',
        containerOrderIdList: [],
        toContainerBatchNo: '',
      },
      containerOptions: [],
      storageList: [],
      storageSync: false,
      totalCategoryPrice: 0,
      transferVisiable: false,
      isActive: false,
      currentdate: '',
      curIndex: '', // 默认选中第0个
      isLoading: true,
      visible: false,
      isVisibleSort: false,
      originColumns, // 初始表头
      columns: [], // 处理后的 全部的表头
      asyncColumns: [], // 接口返回的已选择表头
      orderList: [],
      fileList: [],
      storageList: [],
      menuSettingData: {
        menuId: 'staffContainer'
      },
      rules: {
        senderName: [
          { required: true, message: '进口商不能为空', trigger: 'blur' }
        ],
        senderAddress: [
          { required: true, message: '进口商地址不能为空', trigger: 'blur' }
        ],
        senderPhone: [{ required: true, message: "进口商电话不能为空", trigger: "blur" }
        ],
        senderZipCode: [
          { required: true, message: '进口商邮编不能为空', trigger: 'blur' }
        ],
        senderEmail: [
          { required: true, message: '进口商Email不能为空', trigger: 'blur' }
        ],
        recipientName: [
          { required: true, message: '收件人不能为空', trigger: 'blur' }
        ],
        deliveryAddress: [
          { required: true, message: '收件地址不能为空', trigger: 'blur' }
        ],
        deliveryPhone: [{ required: true, message: "收件人电话不能为空", trigger: "blur" }
        ],
        zipCode: [
          { required: true, message: '收件人邮编不能为空', trigger: 'blur' }
        ],
        /* emailAddress: [
          {required: true, message: 'EMAIL不能为空', trigger: 'blur'},
          {validator: checkEmail}
        ], */
        route: [
          { required: true, message: '线路不能为空', trigger: 'blur' }
        ],
        sendArea: [
          { required: true, message: '收件地区不能为空', trigger: 'blur' }
        ],
        addresserArea: [
          { required: true, message: '进口商地区不能为空', trigger: 'blur' }
        ],
        logisticeCompany: [
          { required: true, message: '物流编号不能为空', trigger: 'blur' }
        ],
        logisticsCompanyId: [
          { required: true, message: '物流编号不能为空', trigger: 'blur' }
        ],
        /* waybillNumber: [
          {required: true, message: '运单号不能为空', trigger: 'blur'}
        ], */
      },
      imgurl: '',
      //上传发票时附带的额外参数
      imgDataObj: {
        policy: '',
        signature: '',
        key: '',
        ossaccessKeyId: '',
        dir: '',
        host: '',
        timeStamp: ''
      },
      queryInfo: {
        containerBatchNo: '',
        userName: '',
        realName: '',
        containerState: '',
        sendArea: '',
        createTimeStart: '',
        createTimeEnd: '',
        sendTimeStart: '',
        sendTimeEnd: '',
        logisticsCompanyId: '',
        logisticeCompany: '',
        waybillNumber: '',
        route: '',
        pageSize: 10,
        pageNum: 1,
      },
      //修改装箱单实体类
      ModifyContainerOrderInfo: {
        containerBatchNo: '',
        recipientName: '',
        deliveryAddress: '',
        deliveryPhone: '',
        zipCode: '',
        senderName: '',
        senderAddress: '',
        senderPhone: '',
        senderZipCode: '',
        senderEmail: '',
        emailAddress: '',
        importCode: '',
        route: '',
        sendArea: '',
        addresserArea: '',
        logisticeCompany: '',
        logisticsCompanyId: '',
        waybillNumber: '',
        comments: '',
        containerOrderContent: ''
      },
      // orderDateRangeValue:[],
      shipDateRangeValue: [],
      containerStateList: [
        {
          value: '0',
          label: '装箱中'
        }, {
          value: '1',
          label: '待支付'
        }, {
          value: '2',
          label: '待传发票'
        }, {
          value: '3',
          label: '待发送'
        }, {
          value: '4',
          label: '已发送'
        }, {
          value: '5',
          label: '已取消'
        }, {
          value: '6',
          label: '待装箱'
        }, {
          value: '7',
          label: '装箱完'
        }, {
          value: '8',
          label: '盘点完'
        }, {
          value: '9',
          label: '待发账单'
        }, {
          value: '10',
          label: '可装箱'
        }, {
          value: '11',
          label: '待确认(国际运费)'
        }
      ],
      routeList: [
        {
          value: '1',
          label: '空运'
        },
        {
          value: '2',
          label: '海运'
        }
      ],
      containerCount: {
        total: 0,
        waitBoxCount: 0,
        canBoxCount: 0,
        boxCount: 0,
        finishBoxNum: 0,
        waitPayCount: 0,
        inventoryCount: 0,
        billCount: 0,
        invoicePendingCount: 0,
        waitSendCount: 0,
        sendCount: 0,
        cancelCount: 0
      },
      aliyunOssToken: {},
      //物流公司的下拉地址
      dropDownList: [],
      dropDownListEdit: [],
      //上传文件
      curRowPDF: 0,
      updataNo: "",
      containerList: [],
      ContainerOrderListVisible: false,
      // 修改页面展示标准
      ModifyPageVisible: false,
      ContainerInfo: "",
      containerOrderList: [],
      splitOrderInfo: {},
      splitForm: {},
      total: 0,
      addGoodsVisiable: false, // 选择商品弹框
      appendageVisiable: false, // 附属品选择商品弹框
      curUserId: null,
      curId: null,
      SelectedGoodsList: [], // 当前已选择的商品
      curContainerState: null, // 当前编辑装箱单的状态
      replyMessageInfo: {},
      replyMessageVisiable: false,
      fbaOptions: [
          {
        name: '否',
        value: '1'
      },
      {
        name: 'FBA',
        value: '0'
      },
      {
        name: 'YFF',
        value: '2'
      },
      {
        name: 'ZOZO',
        value: '3'
      },
      {
        name: 'RSL',
        value: '4'
      }
      ],
      // 装箱单的导出控制
      customerBox: {
        boxStatus: "",
        boxUrl: "",
        pollingTimer: undefined
      },
      maxProfitRate : 38,
      profitRateVisible: false,
      profitRateObj: {
        "batchNo": null,
        "goodsAmount": 0,
        "ordersAmount": 0,
        "freightAmount": 0,
        "totalAmount": 0,
        "goodsAmountJp": 0,
        "ordersAmountJp": 0,
        "freightAmountJp": 0,
        "totalAmountJp": 0,
        "exchangeRate": 0,
        "profitRate": 0
      },
      tractData: [],
      tractMsg: "",
      scrollListener: null,
      scrollTopCache: 0,
      yesVisible: false,
      yseInfo: {
        containerBatchNo: '',
        logisticeCompany: '',
        logisticsCompanyId: '',
        waybillNumber: ''
      },
      yseRules: {
        logisticsCompanyId: [
          { required: true, message: '请选择物流公司', trigger: 'change' }
        ],
        waybillNumber: [
          { required: true, message: "请输入运单号", trigger: "blur" },
          {
            pattern: /^[A-Za-z0-9]+$/,
            message: "只能字母或数字的组合",
            trigger: "blur",
          },
        ],
      }
    }
  },
  created () {
    this.queryInfo.containerBatchNo = this.$route.query.containerBatchNo
    this.getCNameProfitRate()
    this.getAsyncColumns().then(() => {
      this.getContainerCount()
      this.getContainerList()
      this.getDropDownList()
    })
  },
  activated () {
    this.restoreScroll()
    if (this.$route.query.containerBatchNo != '' && this.$route.query.containerBatchNo != undefined && this.queryInfo.containerBatchNo != this.$route.query.containerBatchNo) {
      this.queryInfo.containerBatchNo = this.$route.query.containerBatchNo
      this.getAsyncColumns().then(() => {
        this.getContainerCount()
        this.getContainerList()
        this.getDropDownList()
      })
    }
  },
  methods: {
    // 发货
    handleSend(row){
      this.yesVisible = true
      this.yseInfo.containerBatchNo = row.containerBatchNo
      this.getDropDownList()
    },
    async updateSelect (value) {
      for (let i = 0; i < this.dropDownList.length; i++) {
        if(this.dropDownList[i].id === value) {
          this.yseInfo.logisticeCompany = this.dropDownList[i].companyName
        }
      }
    },
    // 合格弹窗关闭
    yesDialogClose () {
      this.yseInfo.containerBatchNo = ''
      this.yseInfo.logisticeCompany = ''
      this.yseInfo.logisticsCompanyId = ''
      this.yseInfo.waybillNumber = ''
      this.yesVisible = false
    },
    yesSave (formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          const params = {...this.yseInfo}
          const { data: res } = await this.$http.post(
              "container/sendContainer",
              params
          )
          if (res.code === 200) {
            this.$message.success("操作成功")
            this.yesVisible = false
            this.getAsyncColumns().then(() => {
              this.getContainerCount()
              this.getContainerList()
              this.getDropDownList()
            })
          } else {
            this.$message.error(res.message)
          }
        }
      })
    },

    restoreScroll() {
      const bodyWrapper = this.$refs.multipleTable.$el.querySelector('.el-table__body-wrapper');
      this.scrollListener = () => {
        this.scrollTopCache = bodyWrapper.scrollTop;
      };
      bodyWrapper.addEventListener('scroll', this.scrollListener);
      // 如果有缓存滚动位置，恢复
      if (this.scrollTopCache) {
        setTimeout(() => {
          bodyWrapper.scrollTop = this.scrollTopCache;
        },100)
      }
    },
    // 商品总价格
    priceall(){
      this.pricetotal = 0
      this.containerOrderList.forEach(item => {
        this.pricetotal += Number(item.price)*Number(item.containerGoodsCount || 1)
      })
      this.pricetotal = this.pricetotal.toFixed(2)
    },
    // 顺丰物流模板
    SFbox(row,type) {
      this.$http({
        url: "container/exportLogisticsInfo",
        method: "GET",
        params: {
          id: row.id,
          type
        },
        responseType: "blob", //关键点
      }).then(res => {
        //下载文件操作
        const link = document.createElement("a");
        let blob = new Blob([res.data]); //生成blob对象
        link.style.display = "none";
        link.href = URL.createObjectURL(blob);
        link.setAttribute("download", `顺丰物流模板-${type=='sfdb'?'大包.xlsx':'小包.xlsm'}`); //下载的文件名以及文件格式
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }).catch(err => {
        console.error(err);
      })
    },
    // 修改状态
    upDataStatus(row){
      this.$modalDialog(() => import('./cmp/set-status.vue'), {
        row
      }).then(
          () => {
            this.searchList()
          },
          () => {
          }
      )
    },
    // 打开仓储费明细
    handleStorage (row) {
      this.storageSync = true
      this.containerBatchNo = row.containerBatchNo
      this.getStorage(row)
    },
    async getStorage (row) {
      const { data: res } = await this.$http.get('/box/getStorageDetail', { params: { containerBatchNo: row.containerBatchNo } })
      console.log(res, 'res')
      if (res.code == 200) {
        this.storageList = res.data.extWarehouseDetailList
        this.totalCategoryPrice = res.data.totalCategoryPrice
        console.log(this.storageList, 'this.storageList')
      }
    },
    // 运输箱包装明细
    handleExportBoxWrapDetail() {
      this.$http({
        url: "box/exportBoxDetail",
        method: "GET",
        params: {
          containerBatchNo: this.ContainerInfo
        },
        responseType: "blob", //关键点
      }).then(res => {
        //下载文件操作
        const link = document.createElement("a");
        let blob = new Blob([res.data]); //生成blob对象
        link.style.display = "none";
        link.href = URL.createObjectURL(blob);
        link.setAttribute("download", `运输箱包装明细.xlsx`); //下载的文件名以及文件格式
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }).catch(err => {
        console.error(err);
      })
    },
    // 仓储费明细导出
    storageExport () {
      this.$http({
        url: "/box/exportStorageDetail",
        method: "get",
        responseType: "blob", // 表明返回服务器返回的数据类型
        params: { containerBatchNo: this.containerBatchNo },
        headers: {
          "Content-Type": "application/json",
        },
        data: {
          //接口参数
        },
      })
        .then((res) => {
          //创建一个隐藏的a连接，
          const link = document.createElement("a")
          let blob = new Blob([res.data], { type: "application/vnd.ms-excel" })
          link.style.display = "none"
          //设置连接
          link.href = URL.createObjectURL(blob)
          link.download = `仓储费明细${this.containerBatchNo}.xlsm`
          document.body.appendChild(link)
          //模拟点击事件
          link.click()
        })
        .catch((err) => {
          console.log(err)
        })
    },
    onConfirmMsg () {
      this.replyMessageVisiable = false
      this.getContainerList()
    },
    remind (row) {     //提醒
      this.replyMessageInfo = row
      this.replyMessageVisiable = true
    },
    async showProfitRate(batchNo){

      const { data: res } = await this.$http.get(`shop/container/profitRate/${batchNo}`)
      if(res.code !== 200){
        this.$message.error(res.message)
      }else {
        this.profitRateObj = res.data
        this.profitRateObj.batchNo = batchNo
        this.profitRateVisible = true
      }
    },
    async uploadAttachment (file, row) {
      let formdata = new FormData()
      formdata.append('file', file.file)
      const { data: res } = await this.$http.post('cmUser/message/uploadFile', formdata)
      if (res.code === 200) {
        let { fileName, filePath } = res.data
        let attachmentList = this.getAttachment(row.attachment)
        attachmentList.push({ name: fileName, url: filePath, type: 1, customerDelete: 0, operatorDelete: 0 })
        let attachment = ''
        if (attachmentList.length > 0) {
          attachment = JSON.stringify(attachmentList)
        }
        row.attachment = attachment
        this.$set(row, 'attachment', attachment)
        const { data: updateAttachmentRes } = await this.$http.post('container/updateAttachment', { id: row.id, attachment: attachment })
        if (updateAttachmentRes.code !== 200) {
          this.$message.error(updateAttachmentRes.message)
        } else {
          this.$message({
            type: 'success',
            message: '操作成功',
          })
          await this.getContainerList()
        }
      }
    },
    format_with_substring(number) {
      // 数字转字符串, 并按照 .分割
      var arr = (number + '').split('.');
      var int = arr[0] + '';
      var fraction = arr[1] || '';

      // 多余的位数
      var f = int.length % 3;
      // 获取多余的位数，f可能是0， 即r可能是空字符串
      var r = int.substring(0, f);
      // 每三位添加","和对应的字符
      for (var i = 0; i < Math.floor(int.length / 3); i++) {
        r += ',' + int.substring(f + i * 3, f + (i + 1) * 3)
      }

      //多余的位数，上面
      if (f === 0) {
        r = r.substring(1);
      }
      // 整数部分和小数部分拼接
      return r + (fraction ? "." + fraction : '');
    },
    viewAttachment (item) {
      console.log(item)
      fetch(item.url)
          .then(response => response.blob())
          .then(blob => {
            const blobUrl = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = blobUrl;
            a.download = item.name;
            document.body.appendChild(a);
            a.click();
            URL.revokeObjectURL(blobUrl);
            document.body.removeChild(a);
          })
          .catch(error => console.error('Download failed:', error));
      // window.open(item.url, '_blank')
    },
    deleteAttachment (item, row) {
      this.$confirm('确定要删除吗', {
        confirmButtonText: '确定',
        confirmButtonClass: "form-btn btn-blue",
        cancelButtonText: '取消',
        cancelButtonClass: "form-btn btn-gray",
        type: "warning"
      }).then(async () => {
        let attachmentList = this.getAttachment(row.attachment)
        for (let i = 0; i < attachmentList.length; i++) {
          if (item.url == attachmentList[i].url) {
            // attachmentList.splice(i, 1)
            attachmentList[i].operatorDelete = 1
          }
        }
        let attachment = ''
        if (attachmentList.length > 0) {
          attachment = JSON.stringify(attachmentList)
        }
        const { data: res } = await this.$http.post('container/updateAttachment', { id: row.id, attachment: attachment })
        if (res.code !== 200) {
          this.$message.error(res.message)
        } else {
          this.$message({
            type: 'success',
            message: '操作成功',
          })
          row.attachment = attachment
          this.$set(row, "attachment", attachment)
          // await this.getContainerList();
        }
      })
    },
    beforeUploadFile (file, attachment) {
      let attachmentList = this.getAttachment(attachment)
      let fileList = attachmentList.filter((item) => { return item.type === 1 && item.operatorDelete === 0 })

      // const extension = file.name.substring(file.name.lastIndexOf('.'))
      // if (extension !== '.xls' && extension !== '.xlsx' && extension !== '.pdf' && extension !== '.mp4') {
      //   this.$message.warning(this.$t('orderList.orderList137'))
      //   return false
      // }

      if ((fileList.length + 1) > 5) {
        this.$message.error(`最多可上传5个附件`)
        return false
      }
      return true
    },
    saveTransfer () {
      this.$confirm("确定要转移订单吗？", {
        confirmButtonText: "确定",
        confirmButtonClass: "form-btn btn-blue",
        cancelButtonText: "退出",
        cancelButtonClass: "form-btn btn-gray",
        type: "warning"
      }).then(async () => {
        const { data: res } = await this.$http.post("/container/transferOrder", this.transferInfo)
        if (res.code !== 200) {
          this.$message.error(res.message)
        } else {
          this.$message({
            type: "success",
            message: "转移成功!"
          })
          this.transferInfo.toContainerBatchNo = ''
          this.transferInfo.containerOrderIdList = []
          this.transferVisiable = false
          this.ContainerOrderListVisible = false
          await this.getContainerCount()
          await this.getContainerList()
        }
      }).catch(() => {
        this.$message({
          type: "info",
          message: "已退出操作"
        })
      })

    },
    checkboxSelect (row) {
      if (row.id == undefined) {
        return false
      }
      return true
    },
    handleOrderSelectionChange (val) {
      this.transferInfo.containerOrderIdList = val.map(item => item.id)
    },
    async transferOrder () {
      const { data: res } = await this.$http.get('container/getContainerListByCustomerId', { params: { customerId: this.curUserId, containerBatchNo: this.ContainerInfo } })
      this.containerOptions = res.data
      this.transferInfo.oldContainerBatchNo = this.ContainerInfo
      this.transferInfo.toContainerBatchNo = ''
      this.transferVisiable = true
    },
    getAttachment (str) {
      if (str != null && str.length > 0) {
        let attachment = JSON.parse(str)
        console.log(attachment)
        return attachment
      }
      return []
    },
    //删除发票
    delInvoiceUrl (row) {
      this.$confirm("确定要删除发票吗？", {
        confirmButtonText: "确定",
        confirmButtonClass: "form-btn btn-blue",
        cancelButtonText: "退出",
        cancelButtonClass: "form-btn btn-gray",
        type: "warning"
      }).then(async () => {
        const { data: res } = await this.$http.post("/container/quickSave", { id: row.id, invoiceUrl: '', quickSaveType: '1' })
        if (res.code !== 200) {
          this.$message.error(res.message)
        } else {
          this.$message({
            type: "success",
            message: "删除成功!"
          })
          this.fileList = []
          await this.getContainerCount()
          await this.getContainerList()
        }
      }).catch(() => {
        this.$message({
          type: "info",
          message: "已退出操作"
        })
      })
    },
    // 删除输入许可书
    dellicenceUrl (row) {
      this.$confirm("确定要删除输入许可书吗？", {
        confirmButtonText: "确定",
        confirmButtonClass: "form-btn btn-blue",
        cancelButtonText: "退出",
        cancelButtonClass: "form-btn btn-gray",
        type: "warning"
      }).then(async () => {
        const { data: res } = await this.$http.post("/container/quickSave", { id: row.id, invoiceUrl: '', quickSaveType: '3' })
        if (res.code !== 200) {
          this.$message.error(res.message)
        } else {
          this.$message({
            type: "success",
            message: "删除成功!"
          })
          this.fileList = []
          await this.getContainerCount()
          await this.getContainerList()
        }
      }).catch(() => {
        this.$message({
          type: "info",
          message: "已退出操作"
        })
      })
    },
    //快速保存
    async quickSave (value, type, id) {
      if (type === '0') {
        const { data: res } = await this.$http.post("/container/quickSave", { id: id, remark: value, quickSaveType: type })
      }
      if (type === '2') {
        const { data: res } = await this.$http.post("/container/quickSave", { id: id, containerOrderContent: value, quickSaveType: type })
      }
    },
    changeTab (index) {
      this.curIndex = index
      this.searchList()
    },
    imgclick (url, visible) {
      this.visible = true
      this.imgurl = url
    },
    async handleExport () {
      await this.$http.post("box/exportBoxDetail", {
        containerBatchNo: this.ContainerInfo
      }).then((res) => {
        console.log(res)
        if (res.data.code === 200) {
          this.$message({
            type: "success",
            message: res.data.message,
          })
          // 启动轮询
          this.customerBox.boxStatus = '1'
          this.pollingDownload()
        } else {
          this.$message({
            type: "error",
            message: "下载失败",
          })
        }
        //创建一个隐藏的a连接，
        /*const link = document.createElement('a');
        let blob = new Blob([res.data], { type: 'application/vnd.ms-excel' });
        link.style.display = 'none';
        //设置连接
        link.href = URL.createObjectURL(blob);
        link.download = `装箱申请P${date}.xlsx`;
        document.body.appendChild(link);
        //模拟点击事件
        link.click();*/
      }).catch(() => {
      })
    },
    dateFormat (time) {
      let date = new Date(time)
      let year = date.getFullYear()
      let month = date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1
      let day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate()
      let hours = date.getHours() < 10 ? "0" + date.getHours() : date.getHours()
      let minutes = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()
      // 拼接
      return year + '' + month + '' + day + '' + hours + '' + minutes
    },
    async getCNameProfitRate(){
      const { data: res } = await this.$http.get("/CmsName/DICT/maxProfitRate")
      if (res.data){
        this.maxProfitRate = res.data.data
        console.log("------------------maxProfitRate=" ,this.maxProfitRate )
      }
    },
    // 获取已选择列
    getAsyncColumns () {
      return new Promise((resolve) => {
        // 接口start
        this.$http.get("menu/menuSetting", {
          params: {
            menuId: 'staffContainer'
          }
        }).then((res) => {
          var result = []
          if (res.data.code === 200) {
            var record = res.data.data
            this.menuSettingData = record
            result = JSON.parse(record.menuSetting)
          }
          if (result && result.length > 0) {
            result.forEach((item) => {
              this.$set(item, "isShow", true)
            })
            let noSelectList = filterList(
              this.originColumns,
              result,
              "columnId"
            )
            this.columns = result.concat(noSelectList)
            this.asyncColumns = result
            resolve()
          } else {
            this.columns = this.originColumns
            this.columns.forEach((item) => {
              this.$set(item, "isShow", true)
            })
            this.asyncColumns = this.columns
            resolve()
          }
        })
      })
    },
    // 保存选择的列
    doSaveColumns (list) {
      var my = this
      // 接口
      let url = "menu/updateMenuSetting"
      this.menuSettingData.menuSetting = JSON.stringify(list)
      this.$http.post(url, this.menuSettingData).then(res => {
        if (res.data.code === 200) {
          this.isVisibleSort = false
          my.$message({
            type: "success",
            message: "保存成功",
          })
          this.queryInfo.pageNum = 1
          this.getAsyncColumns().then(() => {
            this.getContainerList()
          })
        } else {
          my.$message({
            type: "warning",
            message: "保存失败",
          })
        }
      })
    },
    // 排序
    toSort () {
      this.isVisibleSort = true
    },
    indexMethod (index) {
      return (this.pageNum - 1) * this.pageSize + index + 1
    },
    orderDateRange () {
    },
    shipDateRange () {
    },
    //拆单按钮显示
    showSplitOrderBtn (status) {
      // console.log(status);
      if (status == 0 || status == 4 || status == 8 || status == 12 || status == 16 || status == 48) {
        return true
      } else {
        return false
      }
    },
    queryInfoClear () {
      this.curIndex = '',
        this.queryInfo.containerBatchNo = '',
        this.queryInfo.userName = '',
        this.queryInfo.realName = '',
        this.queryInfo.containerState = '',
        this.queryInfo.sendArea = '',
        this.queryInfo.createTimeStart = '',
        this.queryInfo.createTimeEnd = '',
        this.queryInfo.waybillNumber = '',
        this.queryInfo.route = '',
        this.queryInfo.sendTimeStart = '',
        this.queryInfo.sendTimeEnd = '',
        this.queryInfo.logisticeCompany = '',
        this.queryInfo.logisticsCompanyId = '',
        this.queryInfo.pageSize = 10,
        this.queryInfo.pageNum = 1,
        // this.orderDateRangeValue = [];
        this.shipDateRangeValue = []
    },

    searchList () {
      this.queryInfo.containerState = this.curIndex
      this.queryInfo.pageNum = 1
      this.fileList = []
      this.getContainerCount()
      this.getContainerList()
    },
    toExport() {
      this.getNowFormatDate()
      this.$http({
        url: "cmsContainer/exportContainerList",
        method: "get",
        responseType: "blob", // 表明返回服务器返回的数据类型
        headers: {
          "Content-Type": "application/json",
        },
        params: this.queryInfo,
        data: {
          //接口参数
        },
      }).then((res) => {
        //创建一个隐藏的a连接，
        const link = document.createElement("a")
        let blob = new Blob([res.data], {type: "application/vnd.ms-excel"})
        link.style.display = "none"
        //设置连接
        link.href = URL.createObjectURL(blob)
        link.download = `批次数据${this.currentdate}.xlsx`
        document.body.appendChild(link)
        //模拟点击事件
        link.click()
      }).catch((err) => {
        // console.log(err);
      })
    },
    //保存修改装箱单
    replySave () {
      this.modifyContainerOrder()
    },
    //账单详情
    addBill (e) {
      this.$router.push({
        path: 'containerBillDetail',
        query: {
          id: e.id,
          isAdd: 0,
          containerBatchNo: e.containerBatchNo,
        }
      })
    },
    //发送账单
    async addSendBill (e) {
      const { data: res } = await this.$http.post("cmsContainer/clickBill", { "containerBatchNo": e.containerBatchNo })
      if (res.code == 200) {
        this.$router.push({
          path: 'containerBill',
          query: {
            containerBatchNo: e.containerBatchNo,
            isAdd: 1,
          }
        })
      } else {
        this.$message({
          type: 'warning',
          message: res.message
        })
      }
    },
    categoryFlagChanged (row) {
      //改变状态接口 params row.No,row.categoryFlag
      // console.log(row.categoryFlag);
      setTimeout(() => {
        row.categoryFlag = !row.categoryFlag
        alert('failed')
      }, 1000)

    },
    beforeUploadVideo (index) {
      this.curRowPDF = index
    },
    //上传pdf
    uploadVideo (containerBatchNo, containerState, file) {
      this.fileList = []
      let _self = this
      const isPDF = file.file.type === 'application/pdf'
      const isEXCEL = file.file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      if (!isPDF && !isEXCEL) {
        _self.$message.error('上传文件只能是 PDF和excel 格式!')
        return
      }
      let formdata = new FormData()
      formdata.append('file', file.file)
      formdata.append('modular', 'FBAContainer')
      if (isPDF) {
        formdata.append('type', 'PDF')
      }
      if (isEXCEL) {
        formdata.append('type', 'EXCEL')
      }
      _self.$http.post('aliyun/oss/upload', formdata).then((res) => {
        if (res.data.code == 200) {
          const { data: res1 } = _self.$http.post("cmsContainer/uploadInvoice", {
            "containerBatchNo": containerBatchNo,
            "containerState": containerState,
            "invoiceUrl": res.data.data,
            "invoiceFilename": file.file.name,
          })
          .then((res) => {
            _self.$message.success('上传成功')
            _self.getContainerCount()
            _self.getContainerList()
          })
        }
      })
    },
    uploadLicence (containerBatchNo, containerState, file) {
      this.fileList = []
      let _self = this
      const isPDF = file.file.type === 'application/pdf'
      if (!isPDF) {
        _self.$message.error('上传文件只能是 pdf 格式!')
        _self.fileList = []
        return
      }
      if (file.file.name.includes('.PDF')) {
        _self.$message.error('上传文件只能是 .pdf 格式!')
        _self.fileList = []
        return
      }
      let formdata = new FormData()
      formdata.append('file', file.file)
      formdata.append('modular', 'FBAContainer')
      if (isPDF) {
        formdata.append('type', 'PDF')
      }
      _self.$http.post('aliyun/oss/upload', formdata).then((res) => {
        if (res.data.code == 200) {
          const red = _self.$http.post("cmsContainer/uploadLicence", {
            "containerBatchNo": containerBatchNo,
            "containerState": containerState,
            "licenceUrl": res.data.data,
            "licenceFilename": file.file.name,
          })
          .then((res) => {
            _self.$message.success('上传成功')
            _self.getContainerCount()
            _self.getContainerList()
          })
        }else{
          _self.$message.error(res.data.message)
          _self.fileList = []
        }
      })
    },
    //下载文件
    async downloadFile (row) {
      window.open(row.pdfurl, '_blank')
      // let formdata = new FormData();
      // formdata.append('fileUrl', row.pdfurl)
      // formdata.append('fileName', row.invoiceUrl)
      // var url = 'api/aliyun/oss/download';		// 请求的url + id
      // var xhr = new XMLHttpRequest();
      // xhr.open("POST", url, true)
      // xhr.responseType = "blob";
      // xhr.setRequestHeader("client_type", "DESKTOP_WEB");
      // xhr.setRequestHeader("Authorization", window.sessionStorage.getItem('token'));			// 自定义请求头
      // xhr.onload = function () {
      //   if (this.status == 200) {
      //     var blob = this.response;
      //     var fileName = row.invoiceUrl;
      //     if (window.navigator.msSaveOrOpenBlob) {			// IE浏览器下
      //       navigator.msSaveBlob(blob, fileName);
      //     } else {
      //       var link = document.createElement("a");
      //       link.href = window.URL.createObjectURL(blob);
      //       link.download = fileName;
      //       link.click();
      //       window.URL.revokeObjectURL(link.href);
      //     }
      //   }
      // };
      // xhr.send(formdata);
    },
    async downloadlicenceFile (row) {
      window.open(row.licenceUrl, '_blank')
    },
    handleSuccessImg (index, value) {
      // console.log(index, "-----------------")
      // console.log(value)
      // const {data:res1} =  _self.$http.post("cmsContainer/uploadInvoice",{"containerBatchNo":containerBatchNo,"invoiceUrl":res.data.data});

    },
    cannelBill (row) {
      this.$confirm("确定要取消装箱单吗？", {
        confirmButtonText: "确定",
        confirmButtonClass: "form-btn btn-blue",
        cancelButtonText: "退出",
        cancelButtonClass: "form-btn btn-gray",
        type: "warning"
      }).then(async () => {
        const { data: res } = await this.$http.post(`cmsContainer/modifyContainerOrder`, {
          id: row.id,
          containerState: 5,
          containerBatchNo: row.containerBatchNo
        })
        if (res.code !== 200) {
          this.$message.error(res.message)
        } else {
          this.$message({
            type: "success",
            message: "取消成功!"
          })
          await this.getContainerCount()
          await this.getContainerList()
        }
      }).catch(() => {
        this.$message({
          type: "info",
          message: "已退出操作"
        })
      })
    },
    canBoxStatus (row) {
      this.$confirm("确定要将状态改为可装箱吗？", {
        confirmButtonText: "确定",
        confirmButtonClass: "form-btn btn-blue",
        cancelButtonText: "取消",
        cancelButtonClass: "form-btn btn-gray",
        type: "warning"
      }).then(async () => {


        const { data: res } = await this.$http.post(`container/canBoxStatus`, {
          id: row.id
        })
        if (res.code !== 200) {
          this.$message.error(res.message)
        } else {
          this.$message({
            type: "success",
            message: "操作成功!"
          })

          await this.getContainerCount()
          await this.getContainerList()
        }
      }).catch(() => {
        this.$message({
          type: "info",
          message: "已取消"
        })
      })
    },
    async modifyContainerOrder () {    //修改装箱单
      var my = this
      this.$refs.dialogForm.validate(async function (valid) {
        var url = 'cmsContainer/modifyContainerOrder'
        if (valid) {
          const { data: res } = await my.$http.post(url, my.ModifyContainerOrderInfo)
          if (res.code == 200) {
            my.$message({
              type: 'success',
              message: res.message
            }),
              my.ModifyPageVisible = false
            my.getContainerCount()
            my.getContainerList()
          } else {
            my.$message({
              type: 'warning',
              message: res.message
            })
          }
        }
      })
    },
    async getContainerCount () {
      const { data: res } = await this.$http.get("cmsContainer/getContainerCount", { params: this.queryInfo })
      this.containerCount = res.data
    },
    async getContainerList () {
      this.isLoading = true
      const { data: res } = await this.$http.post("cmsContainer/getAllContainerList", this.queryInfo)
      this.containerList = res.data.list
      this.total = res.data.total
      this.isLoading = false
      // 重新计算表格布局
      this.$nextTick(() => {
        if (this.$refs.multipleTable) {
          this.$refs.multipleTable.doLayout()
        }
      })
    },
    async getContainerOrderList () {
      // 获取装箱单的按钮状态
      this.$http.get('container/getBatchBillStatus', {
        params: {
          containerBatchNo: this.ContainerInfo
        }, headers: {
          noLoading: true
        }
      }).then(({ data: res }) => {
        if (res.code === 200) {
          if (res.data.boxStatus === '1') {
            this.customerBox.boxStatus = res.data.boxStatus
            this.pollingDownload()
          } else {
            this.customerBox.boxStatus = res.data.boxStatus
            this.customerBox.boxUrl = res.data.boxUrl
          }
        } else {
          this.$message.error(res.message)
        }
      }).catch((error) => {
        console.error(error)
      })
      const { data: res } = await this.$http.post("cmsContainer/getContainerOrderList", { containerBatchNo: this.ContainerInfo })
      res.data.forEach(item => {
        this.$set(item, 'maxCount', Number(this._.add(item.canApplyCount, item.containerGoodsCount)))
      })
      this.containerOrderList = res.data.map(v=>{
        return{
          ...v,
          newBoxNum: v.boxNum?.split(",") || []
        }
      })
      this.priceall()
      console.log('this.containerOrderList',this.containerOrderList)
    },
    async getDropDownList () {
      const { data: res } = await this.$http.post("cms/logisticsCompany/getDropDownList")
      this.dropDownList = res.data
    },
    async getDropDownForLineList (line) {
      if (line) {
        const { data: res } = await this.$http.get("cms/logisticsCompany/getDropDownForLineList/" + line)
        this.dropDownListEdit = res.data
      } else {
        this.dropDownListEdit = []
      }

    },
    toContainerDetail (row) {
      // console.log(row);
      this.$router.push({
        name: 'boxList',
        query: {
          containerBatchNo: row.containerBatchNo
        }
      })
    },
    toEditOrder (row) {
      this.$router.push({
        name: 'orderDetail',
        query: {
          id: row.id,
          isEdit: true
        }
      })
    },
    ContainerOrderList (row, customerId, id, containerState) {
      console.log('====',this.containerOrderList);
      this.curUserId = customerId
      this.curId = id
      this.curContainerState = containerState
      this.ContainerOrderListVisible = true
      this.ContainerInfo = row
      this.getContainerOrderList()
    },
    // downBoxUrl (url) {
    //   window.open(url, '_blank')
    // },
    downInvoice(url){
      window.open(url, '_blank')
    },
    // 发票导出
    invoiceExport (row) {

      if(this.getGenerateInvoiceData(row.generateInvoiceData).status == 1){
        return;
      }

      row.generateInvoiceData  = '{"data":"","url":"","status":1}'
      // 导出发票
      this.$http.get('container/exportInvoice', {
        params: {
          id: row.id
        }
      }).then(({ data: res }) => {
        if (res.code === 200) {
          this.$message.success(res.data)
        } else {
          this.$message.error(res.message)
        }
      }).catch((error) => {
        console.error(error)
      })
    },
    getGenerateInvoiceDataStatusStr(str){
      let generateInvoiceData = this.getGenerateInvoiceData(str);
      if(generateInvoiceData.status == 0){
        return '生成发票'
      }else if(generateInvoiceData.status == 1){
        return '正在生成'
      }else if(generateInvoiceData.status == -1 || generateInvoiceData.status == 2){
        return '重新生成'
      }
    },
    getGenerateInvoiceData(str){
      if (str == null || str.length <= 0 ){
        //status -1失败 0未生成 1生成中 2已生成
        return {data:"",url:"",status:0};
      }

      return JSON.parse(str);
    },
    // 当前日期
    getNowFormatDate () {
      let date = new Date(),
        year = date.getFullYear(), //获取完整的年份(4位)
        month = date.getMonth() + 1, //获取当前月份(0-11,0代表1月)
        strDate = date.getDate() // 获取当前日(1-31)
      let hour = date.getHours()
      let minute = date.getMinutes()
      let second = date.getSeconds()
      if (month >= 1 && month <= 9) month = '0' + month // 如果月份是个位数，在前面补0
      if (strDate >= 0 && strDate <= 9) strDate = '0' + strDate // 如果日是个位数，在前面补0
      this.currentdate = `${year}${month}${strDate}${hour}${minute}${second}`
    },
    ModifyContainer (row) {
      this.ModifyPageVisible = true
      this.ContainerInfo = row
      this.routeChange(row.route)
      // this.ModifyContainerOrderInfo.containerBatchNo = row.containerBatchNo;
      this.ModifyContainerOrderInfo = JSON.parse(JSON.stringify(row))
    },
    splitDialogClosed () {
      this.ContainerOrderListVisible = false
      // 关闭的时候清空装箱单的轮询或者状态内容
      this.clearPolling()
      this.customerBox.boxStatus = ""
      this.customerBox.boxUrl = ""
    },
    ModifyPageClosed () {
      this.ModifyPageVisible = false
    },
    splitSave () {

    },
    routeChange (val) {
      console.log(val)
      this.getDropDownForLineList(val)
      this.ModifyContainerOrderInfo.logisticsCompanyId = ''
    },
    handleSizeChange (newSize) {
      this.queryInfo.pageSize = newSize
      this.getContainerCount()
      this.getContainerList()
    },
    handleCurrentChange (newPage) {
      this.queryInfo.pageNum = newPage
      this.getContainerCount()
      this.getContainerList()
    },
    dateFormatYMDHMS (row, column, cellValue, index) {   //交易时间地方的时间格式化
      if (cellValue == null || cellValue == "") return ""
      let date = new Date(parseInt(cellValue) * 1000)//时间戳为10位需*1000，如果为13位的话不需乘1000。
      let Y = date.getFullYear() + '-'
      let M = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) + '-' : date.getMonth() + 1 + '-'
      let D = date.getDate() < 10 ? '0' + date.getDate() + ' ' : date.getDate() + ' '
      let h = date.getHours() < 10 ? '0' + date.getHours() + ':' : date.getHours() + ':'
      let m = date.getMinutes() < 10 ? '0' + date.getMinutes() + ':' : date.getMinutes() + ':'
      let s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
      return Y + M + D + h + m + s
    },
    // 监听选择
    onConfirm (list) {
      console.log(list, this.containerOrderList)
      this.addGoodsVisiable = false
      list.forEach(item => {
        item.orderId = item.id
        item.isAppendage = "0"

        delete item.orderStatusList
        delete item.userId
        delete item.orderIdList
        delete item.pageNum
        delete item.pageSize
        delete item.trackingNumberCn
        delete item.configCheckProjectArray
        if (!this.containerOrderList.some(citem => citem.orderId === item.orderId)) this.containerOrderList.unshift(item)
        delete item.id
      })
    },
    // 监听选择
    onAppendageConfirm (list) {
      console.log(list, this.containerOrderList)
      this.appendageVisiable = false
      list.forEach(item => {
        item.orderId = item.id
        item.isAppendage = "1"

        delete item.userId
        delete item.orderIdList
        delete item.pageNum
        delete item.pageSize
        delete item.trackingNumberCn
        delete item.configCheckProjectArray
        if (!this.containerOrderList.some(citem => citem.orderId === item.orderId)) this.containerOrderList.unshift(item)
        delete item.id
      })
    },
    //删除商品
    delGooods (row) {
      this.containerOrderList.splice(this.containerOrderList.indexOf(row), 1)
    },
    // 保存商品
    onSave () {
      const params = {
        containerId: this.curId,
        containerBatchNo: this.ContainerInfo,
        listOrderJson: JSON.stringify(this.containerOrderList)
      }
      this.$http.post("container/modifyContainerOrder", params).then((res) => {
        if (res.data.code == 200) {
          this.$message.success('保存成功')
          this.getContainerList()
          this.ContainerOrderListVisible = false
        } else {
          this.$message.error(res.data.message)
        }

      }).catch(res => {
        this.$message.error(res.message)
      })
    },
    //判断当前FBA/YFF/ZOZO/RSL 是否可以改变
    handleChangeState (state) {
      if (state == "6" || state == "10" || state == "0" || state == "7" || state == "8") {
        return false
      }
      return true
    },
    async containerStateAlter (row) {
      console.log('row', row)
      var data = {
        id: row.id,
        containerOrderType: row.containerOrderType,
        containerBatchNo: row.containerBatchNo
      }
      var my = this
      var url = 'cmsContainer/modifyContainerOrder'
      const { data: res } = await my.$http.post(url, data)
      if (res.code == 200) {
        my.$message({
          type: 'success',
          message: res.message
        })
        /*if (row.containerOrderType == '1'){
          const { data: res } = await this.$http.post("/container/quickSave", { id: row.id, containerOrderContent: "", quickSaveType: '2' });
        }*/
        my.getContainerCount()
        my.getContainerList()
      } else {
        my.$message({
          type: 'warning',
          message: res.message
        })
      }
    },
    // 轮询炒作查询下载状态
    pollingDownload () {
      if (this.customerBox.boxStatus === '1' && this.ContainerInfo) {
        this.pollingTimer = setTimeout(() => {
          this.$http.get('container/getBatchBillStatus', {
            params: {
              containerBatchNo: this.ContainerInfo
            }, headers: {
              noLoading: true
            }
          }).then(({ data: res }) => {
            if (res.code === 200) {
              if (res.data.boxStatus === '1') {
                clearTimeout(this.customerBox.pollingTimer)
                this.pollingDownload()
              } else {
                this.clearPolling()
                this.customerBox.boxStatus = res.data.boxStatus
                this.customerBox.boxUrl = res.data.boxUrl
              }
            } else {
              this.$message.error(res.message)
              this.clearPolling()
            }
          }).catch((error) => {
            this.clearPolling()
            console.error(error)
          })
        }, 5000)
      }
    },
    // 清空轮询
    clearPolling () {
      if (this.customerBox.pollingTimer) {
        clearTimeout(this.customerBox.pollingTimer)
        this.customerBox.pollingTimer = undefined
      }
    },
    // 打开下载
    handleExportEndBoxDetail (url) {
      if (!url) {
        this.$message.error("error")
        return
      }
      window.open(url, "_blank")
    },
    checkWl(row) {
      // EMS:ems;黑猫:hm;佐川:zc;一番:yf;义达:yd;顺丰:sf
      return row.waybillNumber && ['ems', 'hm', 'zc', 'yf', 'yd', 'sf'].includes(row.logisticsCompanySign);
    },
    getTrach(row, isZdNo) {
      this.tractData = []
      this.tractMsg = ''
      if (this.checkWl(row)) {
        this.$http.get('queryLogisticsInfo/' + (isZdNo ? row.transBillid : row.waybillNumber), {
          headers: {
            noLoading: true
          }
        }).then((res) => {
          const { data: resData } = res;
          if (resData.code === 200) {
            this.tractData = resData.data.trackingInfoList;
          } else {
            this.tractMsg = resData.message;
          }
        });
      }
    }
  },
  watch: {
    //监听时间选择器绑定值变化
    // orderDateRangeValue(){
    //   //解决时间选择器清空后 绑定值为null问题
    //   if(!this.orderDateRangeValue){
    //     this.orderDateRangeValue = [];
    //     this.queryInfo.createTimeStart = '';
    //     this.queryInfo.createTimeEnd = '';
    //   }
    //   else{
    //     if(this.orderDateRangeValue.length>0){
    //       this.queryInfo.createTimeStart = this.orderDateRangeValue[0]/1000;
    //       this.queryInfo.createTimeEnd = this.orderDateRangeValue[1]/1000;
    //     }
    //   }
    //
    // },
    shipDateRangeValue () {
      if (!this.shipDateRangeValue) {
        this.shipDateRangeValue = []
        this.queryInfo.sendTimeStart = ''
        this.queryInfo.sendTimeEnd = ''
      } else {
        if (this.shipDateRangeValue.length > 0) {
          this.queryInfo.sendTimeStart = this.shipDateRangeValue[0] / 1000
          this.queryInfo.sendTimeEnd = this.shipDateRangeValue[1] / 1000
        }
      }
    },
    // '$route.query'(val){
    //   console.log(val);
    //   const {containerBatchNo} = val
    //   this.queryInfo.containerBatchNo = containerBatchNo;
    //   this.getContainerList();
    // }
  },
  beforeDestroy () {
    this.clearPolling()
  },
  mounted () {
    this.restoreScroll()
  },
  // 离开页面
  deactivated() {
    const bodyWrapper = this.$refs.multipleTable.$el.querySelector('.el-table__body-wrapper');
    bodyWrapper.removeEventListener('scroll', this.scrollListener);
  }
};
</script>

<style lang="less" scoped>
.dialog-action{
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.el-table {
  box-flex: 1;
  -webkit-box-flex: 1;
  -moz-box-flex: 1;
  -webkit-flex: 1;
  flex: 1;
}

.el-pagination {
  height: 35px;
  line-height: 35px;
  text-align: center;
}

.split-col {
  padding-right: 20px;
}

.split-title {
  padding: 0 0 10px 0;
  font-size: 15px;
  font-weight: 600;
}

.link:hover,
.server-table i.el-tooltip:hover {
  cursor: pointer;
  color: #409eff;
}
.search-btn-container-status {
  text-align: left !important;
}
.search-row {
  .el-button {
    margin-top: 5px;
  }
}

.container-order-list {
  /deep/.el-table-column--selection {
    text-align: center;
  }
}
.label {
  text-align: left; /* 靠右对齐 */
  font-weight: bold; /* 加粗字体 */
}

/* 值样式 */
.value {
  text-align: right; /* 默认左对齐 */
  font-weight: bold; /* 加粗字体 */
}

.userName{
  width: 100%;
  height: 65%;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  flex-direction: column;
  // flex-wrap: wrap;
  position: absolute;
  top: 50%;
  left: 0;
  transform: translate(0 , -50%);
}
.recipientName{
  text-align: left;
  display: flex;
  flex-direction: column;
}
.font-style1 {
  display: flex;
  justify-content: center;
  width: 100%;
  // justify-content: space-between;
  .left {
    display: flex;
    justify-content: flex-end;
    width: 45px;
    // min-width: 40px;
  }
  .right {
    max-width: calc(100% - 90px);
    min-width: 25px;
    text-align: left;
    flex: 1;
    width: 100%;
    // display: flex;
    // justify-content: flex-end;
    // flex-wrap: nowrap;
  }
  .text-over {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
}


::v-deep.el-form-item--mini .el-form-item__label{
  padding-right: 0 !important;
  line-height: 20px !important;
}
::v-deep.el-form-item--mini .el-form-item__content{
  line-height: 20px !important;
}
::v-deep.el-form-item{
  margin-bottom: 0 !important;
}
::v-deep.tagImg img{
  width: 20px !important;
  height: 20px !important;
}
</style>
